import React from 'react';
import cx from 'classnames';

import { View } from '@dbk/ui-react-utils';

import './blur-modal-footer.css';

export default function Footer({className, children, ...other}) {
  return (
    <View {...other} className={cx(className, 'ModalFooter')}>
      {children}
    </View>
  );
}
